import clsx from 'clsx';
import { ProgressBar } from 'react-aria-components';

import styles from './Spinner.module.css';

export type Props = {
  color?: 'black' | 'white' | 'primary' | 'danger';
  size?: 'small' | 'medium' | 'large';
  'aria-label'?: string;
};

export function Spinner({ color = 'primary', size = 'small', 'aria-label': ariaLabel = 'Loading...' }: Props) {
  return (
    <ProgressBar isIndeterminate aria-label={ariaLabel}>
      <span className={clsx(styles.root, styles[color], styles[size])} />
    </ProgressBar>
  );
}
